function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

// New
function featureLineupChange() {
  $('.featureLineupContainer').each(function () {
    const row_obj = this;
    const titles = $(row_obj).find('.subContainer').find('span.featureLineup-title').detach();
    const btns = $(row_obj).find('.featureLineup-buttons').find('.featureLineup-more').detach();
    const destext = $(row_obj)
      .find('.featureLineupImage a:eq(1)')
      .find('.featureLineup-text')
      .detach();

    $(row_obj).find('.subContainer').find('.featureLineupImage').prepend(titles);
    $(row_obj).find('.subContainer').find('.featureLineupImage').prepend(destext);
    $(row_obj).find('.subContainer').find('.featureLineupImage').append(btns);
  });
}

function countdownShifted() {
  if ($('#body').hasClass('saffireMobileSize')) {
    $('.header #siteInfoBannerWidget').insertBefore('.header .container');
  } else {
    $('.header .headerInnerContent #siteInfoBannerWidget').insertAfter(
      '.saffireLargeSize .header .header-logo',
    );
  }
}

function mobileWindow() {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1080) {
    $('body').addClass('saffireMobileSize').removeClass('saffireLargeSize');
  }
  if (windowSize > 1079) {
    $('body').removeClass('saffireMobileSize');
  }
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  $('.header .ticket').html('<span class="sp-tix">Buy Tickets</span>');

  // Add empty class
  $('.FeatureLineupModule .featureLineupModule .featureLineup-social').each(function () {
    if ($(this).html().trim() == '') {
      $(this).addClass('is-empty');
    }
  });

  // weatherBug
  setInterval(function () {
    let str = $('#weatherBugDescription').text();
    let weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return;
    $('#weatherBugWidget').addClass('weatherBugSet');
    let findSpace = str.lastIndexOf(' ');
    let stringLength = str.length;
    let res = str.substring(findSpace, stringLength);
    let start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);

  modifyBtnNavToggle();
  featureLineupChange();
  mobileWindow();
  countdownShifted();
});

$(window).resize(() => {
  mobileWindow();
  countdownShifted();
});
